<template>
  <div
    class="wallet-card-wrap background-white rounded-regular shadow-light px-3 py-4"
  >
    <div class="heading d-flex flex-column flex-lg-row justify-content-lg-between align-items-center">
      <div class="d-flex flex-column flex-md-row justify-content-center justify-content-md-start text-center text-md-left align-items-center col-lg-6 px-0 px-lg-3">
        <span class="text-color2 font-weight-bold font-size-medium mr-3 mr-lg-5">
          {{ wallet.day | formatDate('DD/MM') }}
        </span>
        <span class="mt-3 mt-md-0 mr-lg-5">
          <label class="font-weight-bold d-block font-size-small mb-0 text-color3">Entrada</label>
          {{ wallet.credit/100 | formatMoney }}
        </span>
        <span class="mt-3 mt-md-0">
          <label class="font-weight-bold d-block font-size-small mb-0 text-color4">Saída</label>
          {{ wallet.debit/100 | formatMoney }}
        </span>
      </div>
      <div
        class="mt-4 mt-lg-0 d-flex align-items-center"
      >
        <div class="mr-3">
          <span class="">
            <label class="font-weight-bold d-block font-size-small mb-0 mr-md-3 mr-lg-4">Total disponível</label>
            {{ (wallet.total_available/100) | formatMoney }}
          </span>
        </div>
        <div
          v-if="expandable"
        >
          <Button
            class="btn-outline-color2"
            @click="open"
            v-if="!isOpen"
          >
            Ver detalhes
          </Button>
          <Button
            class="btn-outline-color2"
            @click="close"
            v-else
          >
            Fechar
          </Button>
        </div>
      </div>
    </div>
    <div
      class="mx-auto col-md-10"
      v-if="isOpen"
    >
      <hr class="h-1 background-color2 my-4" />

      <template
        v-if="loader"
      >
        <Loader
          color="color2"
          size="big"
        />
      </template>
      <template v-else-if="detail">
        <h2 class="font-weight-bold text-color2 font-size-medium mb-4">
          Extrato detalhado do dia
        </h2>
        <div>
          <div
            class="d-flex justify-content-between mb-2"
            v-for="(item, index) in detail"
            :key="index"
          >
            <span class="font-weight-bold">
              <span v-if="item.type === 'credit'">{{ item.quantity }}x</span>
              {{ `${item.entity_type === 'donation' ? 'Cafezinho de ' : ''} ${item.entity_name}` }}
            </span>
            <span
              class="font-weight-bold"
              :class="{
                'text-color3': item.type === 'credit',
                'text-color4': item.type === 'checkout'
              }"
            >
              {{ item.type === 'credit' ? '+' : '-' }} {{ item.amount/100 | formatMoney }}
            </span>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>

import WalletsService from '@/modules/wallets/services/wallets-service'

import Button from '@/components/common/Button/Button'
import Loader from '@/components/common/Loader/Loader'

export default {
  name: 'WalletDayCard',
  props: ['wallet', 'expandable', 'date'],
  components: {
    Button,
    Loader
  },
  data () {
    return {
      isOpen: false,
      detail: null,
      loader: false
    }
  },
  methods: {
    open () {
      this.isOpen = true
      if (!this.detail) this.getDetail()
    },
    close () {
      this.isOpen = false
    },
    async getDetail () {
      this.loader = true
      try {
        const wallet = await WalletsService.getWalletDetail({ date: this.date })
        this.detail = wallet
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.loader = false
    }
  }
}
</script>

<style lang="scss" scoped>
.wallet-card-wrap {
  color: $color1;
}
</style>
